function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import moment from 'moment-strftime';
import { Layout } from '../components/index';
import { htmlToReact, safePrefix } from '../utils';

var Post =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Post, _React$Component);

  function Post() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Post.prototype;

  _proto.render = function render() {
    return React.createElement(Layout, this.props, React.createElement("article", {
      className: "post post-full"
    }, React.createElement("header", {
      className: "post-header"
    }, React.createElement("div", {
      className: "post-meta"
    }, React.createElement("time", {
      className: "published",
      dateTime: moment(_.get(this.props, 'pageContext.frontmatter.date')).strftime('%Y-%m-%d %H:%M')
    }, moment(_.get(this.props, 'pageContext.frontmatter.date')).strftime('%A, %B %e, %Y'))), React.createElement("h1", {
      className: "post-title"
    }, _.get(this.props, 'pageContext.frontmatter.title'))), _.get(this.props, 'pageContext.frontmatter.subtitle') && React.createElement("div", {
      className: "post-subtitle"
    }, htmlToReact(_.get(this.props, 'pageContext.frontmatter.subtitle'))), _.get(this.props, 'pageContext.frontmatter.content_img_path') && React.createElement("div", {
      className: "post-thumbnail"
    }, React.createElement("img", {
      className: "thumbnail",
      src: safePrefix(_.get(this.props, 'pageContext.frontmatter.content_img_path')),
      alt: _.get(this.props, 'pageContext.frontmatter.title')
    })), React.createElement("div", {
      className: "post-content"
    }, htmlToReact(_.get(this.props, 'pageContext.html')))));
  };

  return Post;
}(React.Component);

export { Post as default };